export default __webpack_public_path__ + "static/Денежный поток 303+404-72c5af1b7395c05cec933bedeb0eebb8.png";